export default "__VITE_ASSET__DkjCB8KQ__"